import myRequest from '@/services/myRequest';

// 新建图文转视频
export async function addVideoMaterial(params) {
  return myRequest('post', '/turnToVideo/addVideoMaterial', params);
}
